<template>
	<!-- 执行标准 -->
	<div class="container_page">
		<a-form :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" style="white-space:nowrap;">
			<a-form-item label="用户评价频率设置">
				<span style="display:inline-block;width:20px;">每</span>
				<a-input-number v-model="formData.reputation.minuteInterval" style="width:80px" />
				<span style="display:inline-block;width:40px;text-align:center;">分钟</span>
				<a-input-number v-model="formData.reputation.minuteLimit" style="width:80px" />
				<span style="display:inline-block;width:40px;text-align:center;">次</span>
				<span style="display:inline-block;width:60px;">（上限）</span>
				<a-input-number v-model="formData.reputation.dailyLimit" style="width:100px" />
				<span style="display:inline-block;width:60px;">次/日</span>
				<span style="display:inline-block;width:60px;">（上限）</span>
			</a-form-item>
			<a-form-item label="用户留言频率设置">
				<span style="display:inline-block;width:20px;">每</span>
				<a-input-number v-model="formData.message.minuteInterval" style="width:80px" />
				<span style="display:inline-block;width:40px;text-align:center;">分钟</span>
				<a-input-number v-model="formData.message.minuteLimit" style="width:80px" />
				<span style="display:inline-block;width:40px;text-align:center;">次</span>
				<span style="display:inline-block;width:60px;">上限：</span>
				<a-input-number v-model="formData.message.dailyLimit" style="width:100px" />
				<span style="display:inline-block;width:60px;">次/日</span>
				<span style="display:inline-block;width:60px;">（上限）</span>
			</a-form-item>
			<a-form-item label="意见反馈频率设置">
				<span style="display:inline-block;width:20px;">每</span>
				<a-input-number v-model="formData.feedback.minuteInterval" style="width:80px" />
				<span style="display:inline-block;width:40px;text-align:center;">分钟</span>
				<a-input-number v-model="formData.feedback.minuteLimit" style="width:80px" />
				<span style="display:inline-block;width:40px;text-align:center;">次</span>
				<span style="display:inline-block;width:60px;">（上限）</span>
				<a-input-number v-model="formData.feedback.dailyLimit" style="width:100px" />
				<span style="display:inline-block;width:60px;">次/日</span>
				<span style="display:inline-block;width:60px;">（上限）</span>
			</a-form-item>
			<a-form-item label="代工咨询">
				<span style="display:inline-block;width:20px;">每</span>
				<a-input-number v-model="formData.oemInquiry.minuteInterval" style="width:80px" />
				<span style="display:inline-block;width:40px;text-align:center;">分钟</span>
				<a-input-number v-model="formData.oemInquiry.minuteLimit" style="width:80px" />
				<span style="display:inline-block;width:40px;text-align:center;">次</span>
				<span style="display:inline-block;width:60px;">（上限）</span>
				<a-input-number v-model="formData.oemInquiry.dailyLimit" style="width:100px" />
				<span style="display:inline-block;width:60px;">次/日</span>
				<span style="display:inline-block;width:60px;">（上限）</span>
			</a-form-item>
			<a-form-item label="举报频率设置">
				<span style="display:inline-block;width:20px;">每</span>
				<a-input-number v-model="formData.report.minuteInterval" style="width:80px" />
				<span style="display:inline-block;width:40px;text-align:center;">分钟</span>
				<a-input-number v-model="formData.report.minuteLimit" style="width:80px" />
				<span style="display:inline-block;width:40px;text-align:center;">次</span>
				<span style="display:inline-block;width:60px;">（上限）</span>
				<a-input-number v-model="formData.report.dailyLimit" style="width:100px" />
				<span style="display:inline-block;width:60px;">次/日</span>
				<span style="display:inline-block;width:60px;">（上限）</span>
			</a-form-item>
			<a-form-item style="text-align:center;">
				<a-button type="primary" @click="saveFrequencySetting">保存配置</a-button>
			</a-form-item>
		</a-form>

	</div>
</template>

<script>
	// 后端type -> 页面标题
	const typeLabelMap = {
		REPUTATION: "用户评价频率设置",
		MESSAGE: "用户留言频率设置",
		FEEDBACK: "意见反馈频率设置",
		OEM_INQUIRY: "代工咨询",
		REPORT: "举报频率设置"
	}
	// 页面行key映射，方便双向绑定
	const typeFieldMap = {
		REPUTATION: 'reputation',
		MESSAGE: 'message',
		FEEDBACK: 'feedback',
		OEM_INQUIRY: 'oemInquiry',
		REPORT: 'report'
	}
	import {
		ossUpload
	} from "../../utils/oss";
	import {
		getFrequencySettingApi,
		editFrequencySettingApi
	} from "../../api/index";
	export default {
		name: "cardsList",
		data() {
			return {
				editorOption: {
					modules: {
						toolbar: [
							['bold', 'italic', 'underline', 'strike'],
							['color', 'background'], // 颜色功能在这里
							['clean']

						],
					},
					placeholder: "请输入内容",
					theme: 'snow'
				},
				columns: [{
						title: '序号',
						dataIndex: 'feedbackId',
						key: 'feedbackId',
					},
					{
						title: '反馈单号',
						dataIndex: 'feedbackNo',
						key: 'feedbackNo',
					},
					{
						title: '用户称呼',
						dataIndex: 'nickname',
						key: 'nickname',
					},
					{
						title: '手机号码',
						dataIndex: 'userPhone',
						key: 'userPhone',
					},
					{
						title: '内容',
						dataIndex: 'feedbackContent',
						key: 'feedbackContent',
					},
					{
						title: '反馈时间',
						dataIndex: 'createTime',
						key: 'createTime',
					},
					{
						title: '是否已发送反馈消息',
						dataIndex: 'replyStatus',
						key: 'replyStatus',
						scopedSlots: {
							customRender: 'replyStatusRender'
						},
					},
					{
						title: '处理状态',
						dataIndex: 'status',
						key: 'status',
						scopedSlots: {
							customRender: 'statusRender'
						},
					},
					{
						title: '操作',
						key: 'action',
						scopedSlots: {
							customRender: 'action'
						},
					}
				],
				tableData: [],
				pageInfo: {
					pageSize: 20,
					current: 1,
					total: 0,
					showTotal: (total, range) => {
						return `合计 ${total} 条记录`;
					},
				},
				loading: false,
				imgModel: {
					flag: false,
					url: "",
				},
				labelCol: {
					span: 4
				},
				wrapperCol: {
					span: 18
				},
				filterData: {
					feedbackNo: "",
					nickname: "",
					status: undefined,
					timeDate: [],
				},
				tagsTop: [{
						tagId: 'PENDING',
						tagName: "待处理"
					},
					{
						tagId: 'PROCESSING',
						tagName: "处理中"
					},
					{
						tagId: 'RESOLVED',
						tagName: "已处理"
					},
					{
						tagId: 'RESOLVED',
						tagName: "已关闭"
					}
				],
				// 标签统计数量
				allNum: 0,
				pendingNum: 0,
				processingNum: 0,
				resolvedNum: 0,
				closedNum: 0,
				tags: [{
						tagId: '',
						tagName: "全部",
						numKey: 'allNum'
					},
					{
						tagId: 'PENDING',
						tagName: "待处理",
						numKey: 'pendingNum'
					},
					{
						tagId: 'PROCESSING',
						tagName: "处理中",
						numKey: 'processingNum'
					},
					{
						tagId: 'RESOLVED',
						tagName: "已处理",
						numKey: 'resolvedNum'
					},
					{
						tagId: 'RESOLVED',
						tagName: "已关闭"
					}
				],
				formData: {
					reputation: {
						minuteInterval: 0,
						minuteLimit: 0,
						dailyLimit: 0
					},
					message: {
						minuteInterval: 0,
						minuteLimit: 0,
						dailyLimit: 0
					},
					feedback: {
						minuteInterval: 0,
						minuteLimit: 0,
						dailyLimit: 0
					},
					oemInquiry: {
						minuteInterval: 0,
						minuteLimit: 0,
						dailyLimit: 0
					},
					report: {
						minuteInterval: 0,
						minuteLimit: 0,
						dailyLimit: 0
					}
				}
			};
		},
		created() {},
		activated() {},
		mounted() {
			const storedQuery = localStorage.getItem('msgChannelMng_searchQuery');
			if (storedQuery) {
				this.filterData = JSON.parse(storedQuery);
			} else {}
			this.getData(1)
		},
		beforeRouteLeave(to, from, next) {
			localStorage.setItem('msgChannelMng_searchQuery', JSON.stringify(this.filterData));
			next();
		},
		methods: {

			// res.resultData 是你给的后端数组列表
			fillFormData(list) {
				list.forEach(item => {
					const fieldKey = typeFieldMap[item.interactionType]
					if (!fieldKey) return
					// 赋值到表单，自动填充输入框
					this.formData[fieldKey].settingId = item.settingId
					this.formData[fieldKey].minuteInterval = item.minuteInterval
					this.formData[fieldKey].minuteLimit = item.minuteLimit
					this.formData[fieldKey].dailyLimit = item.dailyLimit
				})
			},

			getData() {
				if (this.loading) {
					return;
				}
				this.loading = true;
				getFrequencySettingApi({})
					.then((res) => {
						if (res.resultStatus) {
							this.tableData = res.resultData.dataList || [];
							this.fillFormData(this.tableData)
						} else {
							this.tableData = [];
							this.fillFormData(this.tableData)
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},

			saveFrequencySetting() {
				// 按后端需要的结构组装数组
				const submitArr = [{
						settingId: this.formData.reputation.settingId,
						interactionType: "REPUTATION",
						minuteInterval: this.formData.reputation.minuteInterval,
						minuteLimit: this.formData.reputation.minuteLimit,
						dailyLimit: this.formData.reputation.dailyLimit
					},
					{
						settingId: this.formData.message.settingId,
						interactionType: "MESSAGE",
						minuteInterval: this.formData.message.minuteInterval,
						minuteLimit: this.formData.message.minuteLimit,
						dailyLimit: this.formData.message.dailyLimit
					},
					{
						settingId: this.formData.feedback.settingId,
						interactionType: "FEEDBACK",
						minuteInterval: this.formData.feedback.minuteInterval,
						minuteLimit: this.formData.feedback.minuteLimit,
						dailyLimit: this.formData.feedback.dailyLimit
					},
					{
						settingId: this.formData.oemInquiry.settingId,
						interactionType: "OEM_INQUIRY",
						minuteInterval: this.formData.oemInquiry.minuteInterval,
						minuteLimit: this.formData.oemInquiry.minuteLimit,
						dailyLimit: this.formData.oemInquiry.dailyLimit
					},
					{
						settingId: this.formData.report.settingId,
						interactionType: "REPORT",
						minuteInterval: this.formData.report.minuteInterval,
						minuteLimit: this.formData.report.minuteLimit,
						dailyLimit: this.formData.report.dailyLimit
					}
				]
				// 调用编辑接口，直接传数组
				editFrequencySettingApi(submitArr).then(res => {
					if (res.resultStatus) {
						this.$message.success("保存成功")
						this.getData() // 刷新最新数据
					} else {
						this.$message.error("保存失败")
					}
				}).catch(err => {
					console.error(err)
					this.$message.error("请求异常")
				})
			},
			toAdd() {},
			toEdit(data) {

			}
		},
	};
</script>

<style lang="less">
	.container_page {
		padding: 20px;
		background: #ffffff;

		.filter_box {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 12px;
		}

		.mr12 {
			margin-right: 12px;
		}
	}

	.size_item {
		height: 50px;
		/* 改为固定高度，不要 min-height */
		background: #f7f7f7;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 8px 0;
		/* 间距改小，更美观 */
		cursor: move;
		padding: 0 10px;

		.left {
			flex: 1;
			padding-left: 10px;
		}

		.right {
			width: 50px;
			text-align: center;
		}
	}

	.lang-radio-wrap {
		display: flex;
		justify-content: center;
		margin-bottom: 16px;
	}
</style>
